import { getTestIds } from 'seagull/utils/TestIds';
import { normalizeContactPhone } from '~/components/ContactForm/ContactForm.utils';
import { associatedCustomersOf } from '../ContactsDashboardRow.utils';
export const editContactIdentityModalTextsPath = 'pages.contactsDashboard.editModal';
export const CONTACT_FIELD_NAME = 'contact';
export const normalizedIdentity = (values)=>({
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        email: values.email.trim(),
        phone: normalizeContactPhone(values.phone)
    });
export const compactPhone = (phone)=>(phone !== null && phone !== void 0 ? phone : '').replace(/\s+/g, '');
export const belongsToManyClients = (contact)=>associatedCustomersOf(contact).length > 1;
export const GetEditContactIdentityModalTID = (parentTestId)=>getTestIds(parentTestId);
